import {
  IEngagement,
  IRequirementDefinitionResponse
} from "@wingspanhq/payments/dist/interfaces";
import { WSActionsMenuItem } from "@wingspanhq/fe-component-library/dist/lib/components/WSActions/WSActions";
import { RequirementDefinitionStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { useArchiveRequirementModal } from "../modals/useArchiveRequirementModal";
import { useArchiveNotAllowedModal } from "../modals/useArchiveNotAllowedModal";
import { useDeleteRequirementModal } from "../modals/useDeleteRequirementModal";
import { useDeleteNotAllowedModal } from "../modals/useDeleteNotAllowedModal";
import { useRestoreRequirementModal } from "../modals/useRestoreRequirementModal";
import { listRequirements } from "../../../services/requirements/listRequirements";
import { useUserId } from "../../../query/hooks/helpers";

type Props = {
  requirementDefinition: IRequirementDefinitionResponse;
  engagements: IEngagement[];
  onDelete?: (requirementDefinition: IRequirementDefinitionResponse) => void;
};

export const useRequirementDefinitionDefaultActions = () => {
  const archiveRequirementModal = useArchiveRequirementModal();
  const archiveNotAllowedModal = useArchiveNotAllowedModal();
  const deleteRequirementModal = useDeleteRequirementModal();
  const deleteNotAllowedModal = useDeleteNotAllowedModal();
  const restoreRequirementModal = useRestoreRequirementModal();

  const userId = useUserId();

  return async (props: Props) => {
    const actions: WSActionsMenuItem[] = [];

    const allConnectedRequirements = await listRequirements({
      filter: {
        payerId: userId,
        requirementDefinitionId:
          props.requirementDefinition.requirementDefinitionId
      },
      page: {
        size: 100
      }
    });

    // engagement is active
    // schema.filter('requirementDefinitionIds', '=');

    const allRequirements = allConnectedRequirements.data;
    const engagementLength = props.engagements.filter(engagement =>
      engagement.requirementDefinitionIds?.includes(
        props.requirementDefinition.requirementDefinitionId
      )
    ).length;

    if (
      props.requirementDefinition.status === RequirementDefinitionStatus.Active
    ) {
      if (engagementLength > 0) {
        actions.push({
          disabled: true,
          onDisabledClick: async () => {
            archiveNotAllowedModal.open({
              requirementDefinition: props.requirementDefinition,
              engagementLength
            });
          },
          label: "Archive",
          icon: "archive"
        });
      } else {
        actions.push({
          onClick: async () => {
            archiveRequirementModal.open({
              requirementDefinition: props.requirementDefinition,
              engagementLength
            });
          },
          label: "Archive",
          icon: "archive"
        });
      }
    } else {
      actions.push({
        onClick: async () => {
          restoreRequirementModal.open({
            requirementDefinition: props.requirementDefinition,
            engagementLength
          });
        },
        label: "Restore",
        icon: "redo"
      });
    }

    if (allRequirements.length > 0) {
      actions.push({
        disabled: true,
        onDisabledClick: async () => {
          deleteNotAllowedModal.open({
            requirementDefinition: props.requirementDefinition,
            engagementLength
          });
        },
        label: "Delete",
        icon: "trash"
      });
    } else {
      actions.push({
        onClick: async () => {
          deleteRequirementModal.open({
            requirementDefinition: props.requirementDefinition,
            engagementLength,
            onSuccess: props.onDelete || (() => {})
          });
        },
        label: "Delete",
        icon: "trash",
        destructive: true
      });
    }

    return actions;
  };
};
